module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_8011.3310236b.png";